import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=5c7b9f0d&"
import script from "./SideCart.vue?vue&type=script&lang=js&"
export * from "./SideCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7b9f0d')) {
      api.createRecord('5c7b9f0d', component.options)
    } else {
      api.reload('5c7b9f0d', component.options)
    }
    module.hot.accept("./SideCart.vue?vue&type=template&id=5c7b9f0d&", function () {
      api.rerender('5c7b9f0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/cart/SideCart.vue"
export default component.exports